import z from "zod";

/**
 * OrdemCompraSchema
 */

export const OrdemCompraSchema = z.object({
  nroOC: z.string().optional(),
  dataCadastro: z.coerce.date().optional(),
  nroColeta: z.string().optional(),
  dataOC: z.coerce.date().optional(),
  centroCusto: z.string().optional(),
  subconta: z.number().optional(),
  comprador: z.string().optional(),
  respAprovacao: z.string().optional(),
  dataEntrega: z.coerce.date().optional(),
  nroCNO: z.string().optional(),
  entrega: z.coerce.number(),
  respDescarga: z.coerce.number(),
  for_nomeFantasia: z.string().optional(),
  for_cnpj: z.string().optional(),
  for_razaoSocial: z.string().optional(),
  for_cpf: z.string().optional(),
  for_contato: z.string().optional(),
  for_email: z.string().optional(),
  for_incricaoEstadual: z.string().optional(),
  for_telFixo: z.string().optional(),
  for_inscricaoMunicipal: z.string().optional(),
  for_telCelular: z.string().optional(),
  for_cep: z.string().optional(),
  for_cidade: z.string().optional(),
  for_rua: z.string().optional(),
  for_numero: z.string().optional(),
  for_complemento: z.string().optional(),
  for_bairro: z.string().optional(),
  for_estado: z.string().optional(),
  for_pais: z.string().optional(),
  informacoesFaturamento: z.number().nullable().optional(),
  fat_nomeFantasia: z.string().optional(),
  fat_cnpj: z.string().optional(),
  fat_razaoSocial: z.string().optional(),
  fat_cpf: z.string().optional(),
  fat_contato: z.string().optional(),
  fat_email: z.string().optional(),
  fat_incricaoEstadual: z.string().optional(),
  fat_telFixo: z.string().optional(),
  fat_inscricaoMunicipal: z.string().optional(),
  fat_telCelular: z.string().optional(),
  fat_cep: z.string().optional(),
  fat_cidade: z.string().optional(),
  fat_rua: z.string().optional(),
  fat_numero: z.string().optional(),
  fat_complemento: z.string().optional(),
  fat_bairro: z.string().optional(),
  fat_estado: z.string().optional(),
  fat_pais: z.string().optional(),
  endereco: z.number().nullable().optional(),
  ent_cep: z.string().optional(),
  ent_cidade: z.string().optional(),
  ent_rua: z.string().optional(),
  ent_numero: z.string().optional(),
  ent_complemento: z.string().optional(),
  ent_bairro: z.string().optional(),
  ent_estado: z.string().optional(),
  ent_pais: z.string().optional(),
  banco: z.number().optional(),
  ban_tipoConta: z.coerce.number().optional(),
  ban_banco: z.string().optional(),
  ban_agencia: z.string().optional(),
  ban_conta: z.string().optional(),
  ban_digito: z.string().optional(),
  ban_operacao: z.string().optional(),
  ban_favorecido: z.string().optional(),
  ban_cpfcnpj: z.string().optional(),
  ban_pix: z.string().optional(),
  informacoesGerais: z.string().optional(),
  observacoes: z.string().optional(),
});

/**
 * OrdemCompraForm
 */

export type OrdemCompraForm = z.infer<typeof OrdemCompraSchema>;

/**
 * initialOrdemCompraForm
 */

export const initialOrdemCompraForm: OrdemCompraForm = {
  nroOC: undefined,
  dataCadastro: undefined,
  nroColeta: undefined,
  dataOC: undefined,
  centroCusto: undefined,
  subconta: undefined,
  comprador: undefined,
  respAprovacao: undefined,
  dataEntrega: undefined,
  nroCNO: undefined,
  entrega: 1,
  respDescarga: 1,
  for_nomeFantasia: undefined,
  for_cnpj: undefined,
  for_razaoSocial: undefined,
  for_cpf: undefined,
  for_contato: undefined,
  for_email: undefined,
  for_incricaoEstadual: undefined,
  for_telFixo: undefined,
  for_inscricaoMunicipal: undefined,
  for_telCelular: undefined,
  for_cep: undefined,
  for_cidade: undefined,
  for_rua: undefined,
  for_numero: undefined,
  for_complemento: undefined,
  for_bairro: undefined,
  for_estado: undefined,
  for_pais: undefined,
  informacoesFaturamento: undefined,
  fat_nomeFantasia: undefined,
  fat_cnpj: undefined,
  fat_razaoSocial: undefined,
  fat_cpf: undefined,
  fat_contato: undefined,
  fat_email: undefined,
  fat_incricaoEstadual: undefined,
  fat_telFixo: undefined,
  fat_inscricaoMunicipal: undefined,
  fat_telCelular: undefined,
  fat_cep: undefined,
  fat_cidade: undefined,
  fat_rua: undefined,
  fat_numero: undefined,
  fat_complemento: undefined,
  fat_bairro: undefined,
  fat_estado: undefined,
  fat_pais: undefined,
  endereco: undefined,
  ent_cep: undefined,
  ent_cidade: undefined,
  ent_rua: undefined,
  ent_numero: undefined,
  ent_complemento: undefined,
  ent_bairro: undefined,
  ent_estado: undefined,
  ent_pais: undefined,
  banco: undefined,
  ban_tipoConta: undefined,
  ban_banco: undefined,
  ban_agencia: undefined,
  ban_conta: undefined,
  ban_digito: undefined,
  ban_operacao: undefined,
  ban_favorecido: undefined,
  ban_cpfcnpj: undefined,
  ban_pix: undefined,
  informacoesGerais: undefined,
  observacoes: undefined,
};